import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchContactInfo, submitContactForm } from '../api/contact-api.js';
import type { ContactSubmitInput } from '../types/contact.js';

/** Public, unauthenticated -- no Clerk token, same as `useBanners`/`useCategories`. */
export function useContactInfo() {
  return useQuery({
    queryKey: ['storefront', 'contact-info'],
    queryFn: ({ signal }) => fetchContactInfo({ signal }),
    staleTime: 60_000,
    retry: 1,
  });
}

export function useSubmitContactForm() {
  return useMutation({
    mutationFn: (input: ContactSubmitInput) => submitContactForm(input),
  });
}
